import { GraphSchema } from '@camelot/server';

import { BankAccount } from './bank-account';

export interface Transaction {
  id: string;
  status: number;
  amount: number;
  currency: string;
  description: string;
  additionalInformation: string;
  creationDate: Date;
  valueDate: Date;
  executionDate: Date;
  bankAccount: BankAccount;
}

export const transactionProps = new GraphSchema<Transaction>([
  'id',
  'status',
  'amount',
  'currency',
  'description',
  'additionalInformation',
  'creationDate',
  'valueDate',
  'executionDate',
  'bankAccount',
]);
